import image1 from "../assets/t-image1.png";
import image2 from "../assets/t-image2.jpg";
import image3 from "../assets/t-image3.jpg";

export const testimonialsData = [
  {
    image: image1,
    review:
      "Fiz a escolha certa ao escolher o Obsidian e ao escolher o plano e programa certo já alcancei meu corpo ideal!",
    name: 'MATHEW HENDRICKSON',
    status : 'EMPREENDEDOR'
  },
  {
    image: image2,
    review: 'A melhor academia na qual eu já fui, não troco por nada! ',
    name: 'JOHN KEVIN',
    status: 'COACH'
  },
  {
    image : image3,
    review:' Amo treinar aqui, professores e aquipe estão de parabéns!!!',
    name: 'FRANKLIN',
    status: "CLIENTE"
  }
];
